import { Outlet } from "react-router-dom"

const PassThrough = () => {
    return (
        <Outlet />
    )
}

export default PassThrough